/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Mem_S1Inputs */

const en_mk_tut_mem_s1 = /** @type {(inputs: Mk_Tut_Mem_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Company memory** and press **Add knowledge**.`)
};

const id_mk_tut_mem_s1 = /** @type {(inputs: Mk_Tut_Mem_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu **Memori perusahaan** lalu tekan **Tambah pengetahuan**.`)
};

/**
* | output |
* | --- |
* | "Open **Company memory** and press **Add knowledge**." |
*
* @param {Mk_Tut_Mem_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_mem_s1 = /** @type {((inputs?: Mk_Tut_Mem_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Mem_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_mem_s1(inputs)
	return en_mk_tut_mem_s1(inputs)
});